import * as request from '@/utils/request'
import { isApiSuccess } from '@/utils/request'

export default {
  post (url, data) {
    return request.post(url, data)
  },
  async getCustomer (id) {
    const res = await request.post('/service/ola_app_customer/detail', { id })
    return { info: (res.data && res.data.detail) ? res.data.detail : {} }
  },
  async getCustomers (params) {
    const res = await request.post('/service/ola_app_customer/list', params)
    if (!isApiSuccess(res)) {
      return { list: [] }
    }
    return { list: (res.data && res.data.list) ? res.data.list : [] }
  },
  async addCustomer (formData) {
    const res = await request.post('/service/ola_app_customer/create', formData)
    if (!isApiSuccess(res) || !res.data || !res.data.detail) {
      return null
    }
    return res.data.detail.id || true
  },
  async modifyCustomer (formData) {
    const res = await request.post('/service/ola_app_customer/update', formData)
    return isApiSuccess(res) ? (formData.id || true) : null
  },
  async deleteCustomer (id) {
    const res = await request.post('/service/ola_app_customer/delete', { id })
    return isApiSuccess(res) ? null : ((res && res.message) ? res.message : '删除失败')
  },
  async getLoginConfig () {
    const res = await request.post('/service/user/login_config', {})
    if (!isApiSuccess(res)) {
      return { otp_enabled: false }
    }
    return (res.data && res.data.detail) ? res.data.detail : { otp_enabled: false }
  },
  async getAdminList (params) {
    const res = await request.post('/service/admin_user/list', params)
    if (!isApiSuccess(res)) {
      return { list: [], pages: { total: 0, offset: 0 } }
    }
    const pageSize = Number(params && params.page_size) || 20
    const currentPage = Number(params && params.current_page) || 1
    const page = (res.data && res.data.page) ? res.data.page : {}
    return {
      list: (res.data && res.data.list) ? res.data.list : [],
      pages: {
        total: page.total || 0,
        offset: (currentPage - 1) * pageSize
      }
    }
  },
  async getAdminInfo (id) {
    const res = await request.post('/service/admin_user/detail', { id })
    return { info: (res.data && res.data.detail) ? res.data.detail : {} }
  },
  async getUser (id) {
    return this.getAdminInfo(id)
  },
  async saveAdmin (formData) {
    const res = await request.post('/service/admin_user/save', formData)
    if (!isApiSuccess(res) || !res.data || !res.data.detail) {
      return null
    }
    return res.data.detail.id || true
  },
  async addUser (formData) {
    return this.saveAdmin(formData)
  },
  async modifyUser (formData) {
    return this.saveAdmin(formData)
  },
  async deleteAdmin (id) {
    const res = await request.post('/service/admin_user/delete', { id })
    if (!isApiSuccess(res) || !res.data || !res.data.detail) {
      return (res && res.message) ? res.message : '删除失败'
    }
    return res.data.detail
  },
  async resetAdminOtp (id) {
    const res = await request.post('/service/admin_user/reset_otp', { id })
    if (!isApiSuccess(res) || !res.data || !res.data.detail) {
      return null
    }
    return res.data.detail
  }
}